<script>
export default {
  data() {
    return {
      title: "Provider Detail",
      text: "Provider Detail",
    };
  },
};
</script>
<template>
  <layout-header></layout-header>
  <services-breadcrumb :title="title" :text="text" />
  <div class="page-wrapper">
    <div class="content content-two">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row gy-3">
                  <div class="col-xl-5">
                    <div
                      class="provider-detail d-flex align-items-center flex-wrap row-gap-2"
                    >
                      <span class="avatar provider-pic flex-shrink-0 me-3">
                        <img src="@/assets/img/profiles/avatar-20.jpg" alt="Img" />
                      </span>
                      <div>
                        <div class="rating mb-2">
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fa-solid fa-star-half-stroke filled me-1"></i>
                          4.9<span class="ms-2 d-inline-block">(255 reviews)</span>
                        </div>
                        <h5 class="d-flex align-items-center mb-1">
                          <router-link to="/service-provider/provider-details">Thomas Herzberg</router-link
                          ><span class="text-success ms-2"
                            ><i class="fa fa-check-circle fs-14"></i
                          ></span>
                        </h5>
                        <p class="mb-2">We connect top talents with top companies</p>
                        <div class="d-flex align-items-center flex-wrap row-gap-2">
                          <p class="mb-0 fs-14 me-2">
                            <i class="feather feather-grid me-1"></i>Electrician
                          </p>
                          <p class="mb-0 fs-14">
                            <i class="ti ti-calendar me-1"></i>Member Since 19 Aug 2023
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="provider-bio-info mb-3">
                          <h6><i></i>Email</h6>
                          <p>thomasxxxxxx@example.com</p>
                        </div>
                        <div class="provider-bio-info">
                          <h6><i></i>Phone Number</h6>
                          <p>+1 888 8XX XXXX</p>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="provider-bio-info mb-3">
                          <h6><i></i>Language Known</h6>
                          <p>
                            English, Arabic <a href="#" class="text-primary">+4 More</a>
                          </p>
                        </div>
                        <div class="provider-bio-info">
                          <h6><i></i>Address</h6>
                          <p>Hanover, Maryland</p>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div>
                          <router-link to="/booking/booking" class="btn btn-primary w-100 mb-3"
                            ><i class="feather-calendar me-2"></i>Book
                            Service</router-link
                          >
                          <h6 class="fw-medium mb-2">Social Profiles</h6>
                          <ul class="social-icon flex-wrap row-gap-2 mb-3">
                            <li>
                              <a href="javascript:void(0);"
                                ><img
                                  src="@/assets/img/icons/fb.svg"
                                  class="img"
                                  alt="icon"
                              /></a>
                            </li>
                            <li>
                              <a href="javascript:void(0);"
                                ><img
                                  src="@/assets/img/icons/instagram.svg"
                                  class="img"
                                  alt="icon"
                              /></a>
                            </li>
                            <li>
                              <a href="javascript:void(0);"
                                ><img
                                  src="@/assets/img/icons/twitter.svg"
                                  class="img"
                                  alt="icon"
                              /></a>
                            </li>
                            <li>
                              <a href="javascript:void(0);"
                                ><img
                                  src="@/assets/img/icons/whatsapp.svg"
                                  class="img"
                                  alt="icon"
                              /></a>
                            </li>
                            <li>
                              <a href="javascript:void(0);"
                                ><img
                                  src="@/assets/img/icons/youtube.svg"
                                  class="img"
                                  alt="icon"
                              /></a>
                            </li>
                            <li>
                              <a href="javascript:void(0);"
                                ><img
                                  src="@/assets/img/icons/linkedin.svg"
                                  class="img"
                                  alt="icon"
                              /></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8">
            <div class="card">
              <div class="card-body">
                <div class="accordion" id="accordionPanelsStayOpenExample">
                  <div class="accordion-item mb-3">
                    <div class="accordion-header" id="accordion-headingOne">
                      <div
                        class="accordion-button p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordion-collapseOne"
                        aria-expanded="true"
                        aria-controls="accordion-collapseOne"
                        role="button"
                      >
                        Overview
                      </div>
                    </div>
                    <div
                      id="accordion-collapseOne"
                      class="accordion-collapse collapse show"
                      aria-labelledby="accordion-headingOne"
                    >
                      <div class="accordion-body p-0 mt-3 pb-1">
                        <div class="more-text">
                          <p class="mb-4">
                            We bring over 20 years of expertise to your doorstep, offering
                            a full range of electrical services tailored to meet the needs
                            of homeowners, businesses, and industrial clients. Our
                            commitment to safety, reliability, and customer satisfaction
                            has made us a trusted name in the industry. Whether you're in
                            need of a simple repair or a complex installation, our team of
                            certified electricians is here to help.
                          </p>
                          <p>
                            we bring over 20 years of expertise to your doorstep, offering
                            a full range of electrical services tailored to meet the needs
                            of homeowners, businesses, and industrial clients.
                          </p>
                        </div>
                        <a
                          href="javascript:void(0);"
                          class="text-primary d-inline-block more-btn mb-2"
                          >Read More</a
                        >
                      </div>
                    </div>
                  </div>
                  <provider-expertise></provider-expertise>
                  <div class="accordion-item mb-3">
                    <div class="accordion-header" id="accordion-headingThree">
                      <div
                        class="accordion-button p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordion-collapseThree"
                        aria-expanded="true"
                        aria-controls="accordion-collapseThree"
                        role="button"
                      >
                        Our Team
                      </div>
                    </div>
                    <div
                      id="accordion-collapseThree"
                      class="accordion-collapse collapse show"
                      aria-labelledby="accordion-headingThree"
                    >
                      <div class="accordion-body p-0 mt-3 pb-1">
                        <div class="row gx-3">
                          <div class="col-xxl-3 col-lg-6 col-md-4 col-sm-6">
                            <div class="d-flex align-items-center team-member mb-3">
                              <span class="avatar avatar-lg flex-shrink-0 me-2">
                                <img
                                  src="@/assets/img/team/team-01.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div>
                                <h6 class="fs-16 fw-medium mb-1">Jeff Fitch</h6>
                                <p class="fs-14">Team Lead</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-xxl-3 col-lg-6 col-md-4 col-sm-6">
                            <div class="d-flex align-items-center team-member mb-3">
                              <span class="avatar avatar-lg flex-shrink-0 me-2">
                                <img
                                  src="@/assets/img/team/team-02.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div>
                                <h6 class="fs-16 fw-medium mb-1">Gary Berger</h6>
                                <p class="fs-14">Senior Electrician</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-xxl-3 col-lg-6 col-md-4 col-sm-6">
                            <div class="d-flex align-items-center team-member mb-3">
                              <span class="avatar avatar-lg flex-shrink-0 me-2">
                                <img
                                  src="@/assets/img/team/team-03.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div>
                                <h6 class="fs-16 fw-medium mb-1">Derrick Bishop</h6>
                                <p class="fs-14">Electrical Engineer</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-xxl-3 col-lg-6 col-md-4 col-sm-6">
                            <div class="d-flex align-items-center team-member mb-3">
                              <span class="avatar avatar-lg flex-shrink-0 me-2">
                                <img
                                  src="@/assets/img/team/team-04.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div>
                                <h6 class="fs-16 fw-medium mb-1">John Reyna</h6>
                                <p class="fs-14">Electrician</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-xxl-3 col-lg-6 col-md-4 col-sm-6">
                            <div class="d-flex align-items-center team-member mb-3">
                              <span class="avatar avatar-lg flex-shrink-0 me-2">
                                <img
                                  src="@/assets/img/team/team-05.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div>
                                <h6 class="fs-16 fw-medium mb-1">Michael Britt</h6>
                                <p class="fs-14">Cable Technician</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-xxl-3 col-lg-6 col-md-4 col-sm-6">
                            <div class="d-flex align-items-center team-member mb-3">
                              <span class="avatar avatar-lg flex-shrink-0 me-2">
                                <img
                                  src="@/assets/img/team/team-06.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div>
                                <h6 class="fs-16 fw-medium mb-1">Homer Ricks</h6>
                                <p class="fs-14">Safety Officer</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-xxl-3 col-lg-6 col-md-4 col-sm-6">
                            <div class="d-flex align-items-center team-member mb-3">
                              <span class="avatar avatar-lg flex-shrink-0 me-2">
                                <img
                                  src="@/assets/img/team/team-07.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div>
                                <h6 class="fs-16 fw-medium mb-1">Chris Frankel</h6>
                                <p class="fs-14">Project Manager</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-xxl-3 col-lg-6 col-md-4 col-sm-6">
                            <div class="d-flex align-items-center team-member mb-3">
                              <span class="avatar avatar-lg flex-shrink-0 me-2">
                                <img
                                  src="@/assets/img/team/team-08.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div>
                                <h6 class="fs-16 fw-medium mb-1">Gary Nunez</h6>
                                <p class="fs-14">Estimator</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <our-services></our-services>
                  <div class="accordion-item mb-3">
                    <div class="accordion-header" id="accordion-headingFive">
                      <div
                        class="accordion-button p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordion-collapseFive"
                        aria-expanded="true"
                        aria-controls="accordion-collapseFive"
                        role="button"
                      >
                        Benefits
                      </div>
                    </div>
                    <div
                      id="accordion-collapseFive"
                      class="accordion-collapse collapse show"
                      aria-labelledby="accordion-headingFive"
                    >
                      <div class="accordion-body p-0 mt-3 pb-1">
                        <div class="row gx-3">
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>Warranty and Support</p>
                            </div>
                          </div>
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>Workmanship Guarantee</p>
                            </div>
                          </div>
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>Energy-Efficient Solutions</p>
                            </div>
                          </div>
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>End-to-End Solutions</p>
                            </div>
                          </div>
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>Personalized Solution</p>
                            </div>
                          </div>
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>Transparent Communication</p>
                            </div>
                          </div>
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>Attention to Detail</p>
                            </div>
                          </div>
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>Top-Notch Materials</p>
                            </div>
                          </div>
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>Strict Safety Protocols</p>
                            </div>
                          </div>
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>Regular Training</p>
                            </div>
                          </div>
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>Comprehensive Knowledge</p>
                            </div>
                          </div>
                          <div class="col-xl-4 col-sm-6">
                            <div class="d-flex align-items-center benifits-item">
                              <span class="text-dark me-2"
                                ><i class="fa fa-check-circle"></i
                              ></span>
                              <p>Qualified Professionals</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <our-branches></our-branches>
                  <our-gallery></our-gallery>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 theiaStickySidebar">
            <div class="stickysidebar">
              <div class="card shadow-none">
                <div class="card-body">
                  <h4 class="mb-3">Contact Provider</h4>
                  <div class="input-group mb-3">
                    <input
                      type="text"
                      class="form-control border-end-0"
                      placeholder="Name"
                    />
                    <span class="input-group-text bg-white"
                      ><i class="ti ti-user"></i
                    ></span>
                  </div>
                  <div class="input-group mb-3">
                    <input
                      type="text"
                      class="form-control border-end-0"
                      placeholder="Phone Number"
                    />
                    <span class="input-group-text bg-white"
                      ><i class="ti ti-phone"></i
                    ></span>
                  </div>
                  <div class="input-group mb-3">
                    <input
                      type="text"
                      class="form-control border-end-0"
                      placeholder="Email Address"
                    />
                    <span class="input-group-text bg-white"
                      ><i class="ti ti-mail"></i
                    ></span>
                  </div>
                  <div class="mb-3">
                    <textarea
                      class="form-control"
                      rows="3"
                      placeholder="Write a Message"
                    ></textarea>
                  </div>
                  <button type="submit" class="btn btn-dark btn-lg w-100">Submit</button>
                </div>
              </div>
              <div class="card shadow-none">
                <div class="card-body lh-1">
                  <h4 class="mb-3">Location</h4>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6509170.989457427!2d-123.80081967108484!3d37.192957227641294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2sin!4v1669181581381!5m2!1sen!2sin"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                    class="contact-map w-100"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <pages-footer></pages-footer>
</template>
